<template>
    <div class="maintenance-vehicle">
        <div class="maintenance-vehicle__buttons">
            <button class="maintenance-vehicle__button"
                    :class="{_active: selectedMethod === 'VehicleVinForm'}"
                    @click="selectedMethod = 'VehicleVinForm'; vinInvalid = false">
                {{ $t('maintenance.lookUpCar') }}
            </button>

            <button class="maintenance-vehicle__button"
                    :class="{_active: selectedMethod === 'VehicleInfoForm'}"
                    @click="selectedMethod = 'VehicleInfoForm'">
                {{ $t('maintenance.addCar') }}
            </button>
        </div>

        <div v-if="vinInvalid" class="vehicle__error _vin-invalid">
            <div class="validation-error">
                {{ $t('maintenance.invalidVIN') }}
            </div>
        </div>
        <component class="maintenance-vehicle__component"
                   :is="selectedMethod"
                   :sending="sending"
                   v-if="readyToRenderForm"
                   @vinUpdated="checkVin($event)"
                   @vehicleInfoUpdated="updateVehicleInfo($event)"/>
        <step-preloader v-else/>
    </div>
</template>

<script>
    import VehicleInfoForm from '../../components/VehicleInfoForm.vue'
    import VehicleVinForm from '../../components/VehicleVinForm.vue'

    export default {
        name: 'MaintenanceVehicle',
        data() {
            return {
                selectedMethod: 'VehicleVinForm',
                vinInvalid: false,
                sending: false,
                readyToRenderForm: false
            }
        },
        methods: {
            checkVin($event) {
                this.sending = true;
                this.$store.dispatch('checkVehicleInfo', {
                    data: {
                        vin: $event.vin,
                        mileage: $event.mileage
                    },
                    entryType: 'vin'
                }).then(() => {
                    this.sending = false;
                    this.$router.push({name: 'MaintenanceDealer'})
                }).catch(() => {
                    this.sending = false;
                    this.selectedMethod = 'VehicleInfoForm';
                    this.vinInvalid = true;
                })
            },
            updateVehicleInfo($event){
                this.sending = true;
                this.$store.dispatch('checkVehicleInfo', {data: $event, entryType: 'info'})
                    .then(() => {
                        this.sending = false;
                        this.$router.push({name: 'MaintenanceDealer'})
                    })
                    .catch(err => {
                        this.sending = false;
                    });
            },
        },
        beforeMount() {
            if(this.$store.state.maintenanceSelected.vehicleInfoEntryType === 'info') {
                this.selectedMethod = 'VehicleInfoForm';
            }


            this.$store.dispatch('setMaintenanceCities').then(() => {
                this.readyToRenderForm = true
            });
        },
        components: {
            VehicleInfoForm,
            VehicleVinForm
        }
    }
</script>

<style lang="less" >

    @import (less) '../../styles/_media.less';
    @import (less) '../../styles/colors.less';
    @import (less) '../../styles/paddings.less';

    .maintenance-vehicle{
        &__buttons {
            display: flex;
        }

        &__button {
            text-align: left;
            border-radius: 0;
            border: 1px solid @backgroundDark;
            outline: none;
            background-color: white;
            cursor: pointer;
            .paddings;

            &:hover {
                border: 1px solid @backgroundDark !important;
                background-color: white !important;
            }

            font-size: 10px;
            text-transform: uppercase;
            letter-spacing: 2px;

            @media @phone-strict {
                width: 50%;
            }

            .jaguar-style & {
                font-family: 'Proxima Nova - Semibold', Helvetica, Arial, sans-serif;
            }

            .land-rover-style & {
                font-family: Arial, sans-serif;
            }

            &._active {
                background-color: @backgroundDark;

                &:hover {
                    background-color: @backgroundDark !important;
                }
            }
        }

        &__component {
            background-color: @backgroundDark;
            margin: 0 auto;
            .paddings;
        }

        .submit-button {
            width: 100%;
        }

        .jlr-select.v-select {
            .selected-tag {
                line-height: 40px;
            }
        }

        .user-location {
            &__select.v-select {
                font-size: 10px;
                width: 100%;
                letter-spacing: 2px;

                .dropdown-toggle {
                    input {
                        text-transform: uppercase;
                        letter-spacing: 2px;
                    }
                }

                .selected-tag {
                    padding: 0 0 0 20px !important;
                }

                .form-control {
                    padding-left: 20px !important;
                }

                .dropdown-menu {
                    li {
                        a {
                            padding: 5px 0 5px 20px;
                        }
                    }
                }
            }

            &._error {
                .user-location__select {
                    border: 2px solid @errorColor;
                }
            }
        }
    }


    .vehicle {
        &__form {
            position: relative;
        }

        &__groups {
            text-align: left;

            @media @tablet {
                margin-bottom: -11px;
                padding-right: 180px;
            }
        }

        &__group {
            vertical-align: top;
            width: 100%;
            margin-bottom: 10px;

            @media @tablet {
                display: inline-block;
                margin-right: 10px;
            }
        }

        &__select {
            background-color: white;
            box-sizing: border-box;
            padding: 0 20px;
            height: 40px;

            &._error {
                border: 2px solid red;
            }
        }

        &__input {
            box-sizing: border-box;
            border: none;
            padding: 0 20px;
            font-size: 10px;
            letter-spacing: 2px;
            width: inherit;
            outline: none;
            height: 40px;

            &::placeholder {
                text-transform: uppercase;
            }

            &._error {
                border: 2px solid @errorColor;
            }
        }

        &__errors {
            padding-top: 3px;
            margin-left: 10px;
        }

        &__error {
            &._vin-invalid {
                background-color: @backgroundDark;
                padding-top: @verticalPadding;
                .horizontal-paddings;
            }
        }

        &__button {
            margin-top: 10px;
            color: @landRoverBlack;

            @media @tablet {
                margin-top: 0;
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/MaintenanceVehicle.vue